import React from 'react';
import { useOutletContext } from 'react-router-dom';
import DashboardLayout from '@/components/DashboardLayout';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Banknote } from 'lucide-react';

const OwnerPayments = () => {
  const { user } = useOutletContext();
  
  return (
    <DashboardLayout user={user}>
      <div className="space-y-6">
        <div>
          <h1 className="text-4xl font-heading font-bold text-primary mb-2">Manage Payments</h1>
          <p className="text-muted-foreground">Mark invoices as paid and upload payment proof</p>
        </div>
        
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Banknote className="w-5 h-5 text-accent" />
              Payments Module
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-center py-12">
              <p className="text-muted-foreground">Payment management - mark invoices paid, upload proof, add payment references</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default OwnerPayments;
